import { defineStore } from "pinia";

import {
  type IKundserviceAppApiClient,
  PlatformData,
} from "@/composables/KundserviceAppApiClient";

interface MockDataState {
  loading: boolean;
  data?: PlatformData;
}

export const useMockDataStore = defineStore("mockData", {
  state: (): MockDataState => ({
    loading: false,
    data: undefined,
  }),
  actions: {
    async fetchMockData(
      individId: string,
      apiClient: IKundserviceAppApiClient,
    ) {
      try {
        this.loading = true;
        this.data = await apiClient.getPlatformData(individId);
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async setMockData(
      individId: string,
      setMockData: PlatformData,
      apiClient: IKundserviceAppApiClient,
    ) {
      try {
        this.loading = true;

        await apiClient.mockData(individId, setMockData);
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async clearMockData(
      individId: string,
      apiClient: IKundserviceAppApiClient,
    ) {
      try {
        this.loading = true;

        await apiClient.clearData(individId);
        this.data = undefined;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
  },
});
